<template>
  <div>
    <message-list-component
        :messages="errors" type="danger" clear-mutation="clearErrors"
        :show-delete-button="showDeleteButton" :show-icon="showIcon"
    >
      <template v-for="slot in possibleChildSlotsFor('Message','danger')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </message-list-component>
    <message-list-component
        :messages="warnings" type="warning" clear-mutation="clearWarnings"
        :show-delete-button="showDeleteButton" :show-icon="showIcon"
    >
      <template v-for="slot in possibleChildSlotsFor('Message', 'warnings')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </message-list-component>
    <message-list-component
        :messages="successes" type="success" clear-mutation="clearSuccesses"
        :show-delete-button="showDeleteButton" :show-icon="showIcon"
    >
      <template v-for="slot in possibleChildSlotsFor('Message', 'successes')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </message-list-component>
  </div>
</template>
<script>
import MessageBase from './MessageBase'
import MessageListComponent from '@/components/generic/MessageView/MessageListComponent'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'MessageModal',
  extends: MessageBase,
  components: {
    MessageListComponent
  },
  mixins: [
    slotProxy()
  ],
  props: {
    showDeleteButton: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  }
}
</script>
